module.exports = __webpack_public_path__ + "static/media/eating.c7d96f42.svg";